import {
    apiRequest,
    HDDownloadSP
} from "../../../../../services/adapters/kepegawaian/hukumanDisiplinService"

class IndexRepository {

    fetchDownloadSP = async (query) => {
        return await apiRequest("get", HDDownloadSP, {
            params: query
        }, true)
    }
}

export default IndexRepository